import { z } from 'zod';

export const $CandidateRegion = z.object({
  id: z.number(),
  name: z.string(),
});
